import request from '@/utils/request'

let OfficiaApi = {
    /*获取数据*/
    getData(data) {
        return request._get('/shop/plus.officia/index', data);
    },
    /*保存数据*/
    saveData(data) {
        return request._post('/shop/plus.officia/index', data);
    },
}
export default OfficiaApi;



// WEBPACK FOOTER //
// ./src/api/officia.js